import Title from './Title';

export { TitleKind, TitleSize } from './Title';
export default Title;
